export const PATH = {
    ErrorPage: '/ErrorPage',
    FormPage: '/FormPage',
    Home: '/Home',
    WorkersList: '/WorkersList',
    PatientList: '/PatientList',
    ScanPage: '/ScanPage',
    RegistrationForm: '/FindPatientForm',
    LaborantForm: '/LaborantForm',
    DoctorForm: '/DoctorForm',
    Referrals: '/Referrals',
    Anamnez: '/PatientCard/:id',
    NewUser: '/CreateNewUser',
    NewClinic: '/CreateClinic',
    EditUser: '/EditUser/:id',
    EditPatient: '/EditPatient/:id',
    ReferralCard: '/ReferralCard/:id',
    ReferralCardEdit: '/ReferralCardEdit/:id',
    LogsPage: '/LogsPage',
    Contracts: '/Contracts',
    ClinicList: '/ClinicList',
    EditClinic: '/EditClinic/:id',
    Statistics: '/Statistics',
    NewContracts: '/NewContracts',
    EditContract: '/EditContract'
}